import React from 'react';
import classNames from 'classnames';
import { CheckOutline } from 'antd-mobile-icons';
import { isFunction } from 'lodash';
import '../style/index.less.js';

var SelectorItem = function SelectorItem(props) {
  var _a = props.active,
    active = _a === void 0 ? false : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    option = props.option,
    onItemClick = props.onItemClick;
  var itemCls = classNames({
    'ti-selector-item': true,
    'ti-selector-item-active': active,
    'ti-selector-item-disabled': disabled
  });
  var handleItemClick = function handleItemClick() {
    if (isFunction(onItemClick)) {
      onItemClick(option, !active);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: itemCls,
    onClick: handleItemClick
  }, option.label, active ? /*#__PURE__*/React.createElement("div", {
    className: "ti-selector-item-mask"
  }, /*#__PURE__*/React.createElement(CheckOutline, {
    className: "ti-selector-item-mask-icon",
    color: "#fff"
  })) : null);
};

export { SelectorItem as default };
